import React from 'react';
import { Heart, Calendar, MessageSquare, Eye, ArrowRight } from 'lucide-react';
import { properties } from '../../data/mockData';
import { PropertyCard } from '../../components/shared/PropertyCard';
export const BuyerDashboard = () => {
  const savedProperties = properties.slice(0, 2);
  return <div className="space-y-8 animate-in fade-in" data-id="element-1367">
      <div data-id="element-1368">
        <h1 className="text-2xl font-serif font-bold text-primary-900 mb-1" data-id="element-1369">
          Welcome back, John
        </h1>
        <p className="text-text-light" data-id="element-1370">
          Here's an overview of your real estate journey.
        </p>
      </div>

      {/* Overview Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1371">
        {[{
        label: 'Saved Properties',
        value: '12',
        icon: Heart,
        color: 'text-error',
        bg: 'bg-error/10'
      }, {
        label: 'Upcoming Inspections',
        value: '2',
        icon: Calendar,
        color: 'text-primary-600',
        bg: 'bg-primary-50'
      }, {
        label: 'Unread Messages',
        value: '5',
        icon: MessageSquare,
        color: 'text-secondary-dark',
        bg: 'bg-secondary/10'
      }, {
        label: 'Recently Viewed',
        value: '24',
        icon: Eye,
        color: 'text-neutral-dark',
        bg: 'bg-neutral-200'
      }].map((stat, i) => {
        const Icon = stat.icon;
        return <div key={i} className="bg-white p-5 rounded-2xl shadow-sm border border-neutral-200 flex items-center gap-4" data-id="element-1372">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${stat.bg} ${stat.color}`} data-id="element-1373">
                <Icon size={24} data-id="element-1374" />
              </div>
              <div data-id="element-1375">
                <div className="text-2xl font-bold text-text" data-id="element-1376">{stat.value}</div>
                <div className="text-xs font-bold text-text-light uppercase tracking-wider" data-id="element-1377">
                  {stat.label}
                </div>
              </div>
            </div>;
      })}
      </div>

      <div className="grid lg:grid-cols-3 gap-8" data-id="element-1378">
        {/* Main Content Area */}
        <div className="lg:col-span-2 space-y-8" data-id="element-1379">
          {/* Saved Properties */}
          <div className="bg-white rounded-2xl shadow-sm border border-neutral-200 p-6" data-id="element-1380">
            <div className="flex items-center justify-between mb-6" data-id="element-1381">
              <h2 className="text-lg font-serif font-bold text-primary-900" data-id="element-1382">
                Recently Saved
              </h2>
              <button className="text-sm font-bold text-secondary hover:text-secondary-dark flex items-center gap-1" data-id="element-1383">
                View All <ArrowRight size={16} data-id="element-1384" />
              </button>
            </div>
            <div className="grid sm:grid-cols-2 gap-6" data-id="element-1385">
              {savedProperties.map(p => <PropertyCard key={p.id} property={p} data-id="element-1386" />)}
            </div>
          </div>
        </div>

        {/* Sidebar Area */}
        <div className="space-y-8" data-id="element-1387">
          {/* Upcoming Inspections */}
          <div className="bg-white rounded-2xl shadow-sm border border-neutral-200 p-6" data-id="element-1388">
            <h2 className="text-lg font-serif font-bold text-primary-900 mb-6" data-id="element-1389">
              Upcoming Inspections
            </h2>

            <div className="space-y-4" data-id="element-1390">
              {[1, 2].map(i => <div key={i} className="flex gap-4 p-4 rounded-xl border border-neutral-100 bg-neutral-50" data-id="element-1391">
                  <div className="w-12 h-12 rounded-lg bg-primary-900 text-white flex flex-col items-center justify-center shrink-0" data-id="element-1392">
                    <span className="text-xs font-medium uppercase" data-id="element-1393">Oct</span>
                    <span className="text-lg font-bold leading-none" data-id="element-1394">2{i}</span>
                  </div>
                  <div data-id="element-1395">
                    <h4 className="font-bold text-text text-sm mb-1 line-clamp-1" data-id="element-1396">
                      Luxury 5-Bed Duplex
                    </h4>
                    <p className="text-xs text-text-light flex items-center gap-1 mb-2" data-id="element-1397">
                      <Calendar size={12} data-id="element-1398" /> 10:00 AM
                    </p>
                    <span className="text-[10px] font-bold px-2 py-1 bg-secondary/10 text-secondary-dark rounded uppercase" data-id="element-1399">
                      Confirmed
                    </span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
};